import { Link } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Card, EmptyState, PageHeader } from "../components/ui";

/** The empty shell; the apprentice's Home (ACC-04) replaces it with Slice A. Signed in, it says who and where. */
export function HomePage() {
  const { status, me, config } = useAuth();
  const productName = me?.tenant.productName ?? config.productName;
  if (status === "signed-in" && me) {
    return (
      <>
        <PageHeader title="Home" subtitle={`Signed in to ${productName} as ${me.person.displayName}.`} />
        <Card title="Your account">
          <dl className="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-[auto_1fr]">
            <dt className="text-muted">Name</dt>
            <dd data-testid="me-name">{me.person.displayName}</dd>
            <dt className="text-muted">Email</dt>
            <dd>{me.person.email}</dd>
            <dt className="text-muted">Organization</dt>
            <dd>{me.tenant.displayName}</dd>
            {me.identityProvider && (
              <>
                <dt className="text-muted">Signs in through</dt>
                <dd>{me.identityProvider}</dd>
              </>
            )}
          </dl>
          <p className="mt-4">
            <Link to="/account/security">Security: passkeys, authenticator, password, activity</Link>
          </p>
        </Card>
        <div className="mt-6">
          <EmptyState title="Nothing to do yet" hint="The first apprentice flows — applying, signing an agreement, logging hours — arrive with Slice A." />
        </div>
      </>
    );
  }
  return (
    <>
      <PageHeader title="Home" subtitle={`${productName} is being built.`} />
      <EmptyState title="Nothing here yet" hint="Sign in to see your account." action={<Link to="/login">Sign in</Link>} />
    </>
  );
}
